import { CWComponents } from "@channelwill/components"
import { useSelector } from "react-redux";
import { useEffect } from "react"
 const Index = () => {
  // 从全局存储里获取商家地址&商家的语种
  const shopInfo = useSelector(
    (state) => state.languageReducer.subScriptData
  );
  
  useEffect(() => {
    if (!shopInfo) return
    // 组件库初始化
    CWComponents.init({
      // 根据环境变量选择对应的中台环境
      baseUrl: process.env.REACT_APP_CHANNELWILL_COMPONENTS,
      // 引入组件的相关映射:
      // { 业务分类 :{' 组件唯一key值 '}}
      componentMaps: {
        "recommendations": ['home_recommend_solution'],
      },
      appId: process.env.REACT_APP_CW_KEY,
      lang: shopInfo.language,
      shopifyDomain: shopInfo.domain
    })
  }, [shopInfo])
  return (
    <></>
  )
}
export default Index;